module.exports = __webpack_public_path__ + "img/figure1_source.d994e061.png";